import anime from 'animejs/lib/anime.es.js';
import CookiePopup from '../components/CookiePopup'

export default {
  init() {

    function checkIfMobile() {
      if (jQuery(window).innerWidth < 764) {
        return true;
      }
      return false;
    }

    const cookiePopup = new CookiePopup();
    const svgPath = document.querySelectorAll('.line');
    let menuFixed = false;
    const isAdmin = jQuery('body').hasClass('admin-bar');
    const navContainer = jQuery('.nav-desktop');
    let menuHeight = navContainer.height();
    const $ = jQuery;
    // Create a timeline with default parameters

    var tabNavItem = $('.service-tabs__nav-link');
    var firstTabNavItem = $(tabNavItem)[0];
    var firstTabNavContent = $(firstTabNavItem).attr('href');
    // JavaScript to be fired on the home page
    if (tabNavItem) {
      $(firstTabNavItem).addClass('active');
      $(firstTabNavContent).addClass('visible');
      tabNavItem.on('click', function(event) {
        event.preventDefault();
        var target = $(this).attr('href');
        $('.service-tabs__nav-link').removeClass('active');
        $('.service-tabs__item').removeClass('visible');
        $(this).addClass('active');
        $(target).addClass('visible');
        const targetObject = document.getElementById(target.replace('#', ''));
        const services =  targetObject.querySelectorAll('.service');
        anime({
          easing: 'easeInOutSine',
          duration: 750,
          targets: services,
          opacity: [0.5, 1],
          translateY: [-30, 0],
          delay: anime.stagger(200), // increase delay by 100ms for each elements.
        });
      })
    }

    cookiePopup.init();

    // jQuery(window).on('scroll', function () {

    //   const isMobile = checkIfMobile();
    //   let height = isAdmin ? 32 : 0;

    //   if (isAdmin && isMobile) {
    //     height = 46;
    //   }

      
    //   menuHeight = navContainer.height();
    //   if (jQuery(this).scrollTop() > menuHeight) {
    //     if (menuFixed) return;
    //     navContainer.addClass('is-fixed');
    //     menuFixed = true;
    //     anime({
    //       easing: 'easeInOutSine',
    //       duration: 300,
    //       targets: document.querySelector('.nav-desktop'),
    //       opacity: 1,
    //       top: ['-'+menuHeight, height],
    //     })
    //   } else {
    //     if (!menuFixed) return;
    //     anime({
    //       easing: 'easeInOutSine',
    //       duration: 300,
    //       targets: document.querySelector('.nav-desktop'),
    //       top: height,
    //       complete: function() {
    //         navContainer.removeClass('is-fixed');
    //         menuFixed = false;
    //       },
    //     })
    //   }
    // });

    // START Mobile Menu

    var menuToggle = jQuery('.nav__toggle');
    var navMobile = jQuery('.nav-mobile');
    var nav = document.querySelector('.nav-mobile .nav-primary');
    var mobileMenuItem = navMobile.find('.menu-item > a');

    var animateLogo = anime({
      autoplay: false,
      easing: 'easeInOutSine',
      duration: 500,
      targets: svgPath,
      loop: false,
      direction: 'normal',
      strokeDashoffset: [anime.setDashoffset, 0],
      delay: (el, i) => { return i * 100 },
    })
    
    var animateMenu = anime({
      autoplay: false,
      easing: 'easeInOutSine',
      duration: 300,
      targets: nav,
      opacity: 1,
      translateX: ['-'+$(window).innerWidth(), 0],
      begin: function(anim) {
        $(nav).addClass('visible');
      },
      complete: function(anim) {
        anim.reverse()
      },
    })

    var Menu = {
      visible: false,
      show: function() {
        $('body').addClass('menu-open');
        navMobile.addClass('menu-open');
        menuToggle.addClass('nav__toggle--active');
        animateMenu.play()
        animateLogo.play()
        Menu.visible = true;
      },
      hide: function(url) {
        $('body').removeClass('menu-open');
        navMobile.removeClass('menu-open');
        menuToggle.removeClass('nav__toggle--active');
        animateMenu.play()
        animateLogo.play()
        Menu.visible = false;
        if (url) {
          window.location.href = url;
        }
      },
    }

    mobileMenuItem.on('click', function(event) {
      event.preventDefault();
      var url = $(this).attr('href');
      Menu.hide(url);
    })

    menuToggle.on('click', function(event) {
      event.preventDefault();
      if (Menu.visible) {
        Menu.hide()
        return
      }
      Menu.show()
    })

    // END Mobile Menu

    var menuItem = jQuery('.nav > .menu-item-has-children');
    var subMenu = menuItem.find('.sub-menu');
    menuItem.on('mouseover', function(event) {
      event.stopPropagation();
      var menuHeight = jQuery('.nav-desktop').height();
      $(this).addClass('sub-menu-active');
      $(subMenu[0]).addClass('visible');
      anime({
        easing: 'easeInOutSine',
        duration: 300,
        targets: subMenu[0],
        opacity: 1,
        top: (menuHeight-1)+'px',
      })
    })
    menuItem.on('mouseleave', function(event) {
      event.stopPropagation();
      var menuHeight = jQuery('.nav-desktop').height();
      var that = $(this);
      anime({
        easing: 'easeInOutSine',
        duration: 300,
        targets: subMenu[0],
        opacity: 0,
        top: (menuHeight+20) + 'px',
        complete: function() {
          that.removeClass('sub-menu-active');
          $(subMenu[0]).removeClass('visible');
        },
      })
    })

    var tl = anime.timeline({
      easing: 'easeInOutSine',
      duration: 750,
    });

    // Add children
    tl
    .add({
      targets: svgPath,
      loop: false,
      direction: 'normal',
      strokeDashoffset: [anime.setDashoffset, 0],
      delay: (el, i) => { return i * 300 },
    })
    anime({
      easing: 'easeInOutSine',
      duration: 500,
      targets: '.hero__content',
      opacity: [0, 1],
      translateY: [-50, 0],
      delay: 100,
      complete: function() {
        cookiePopup.init()
      },
    })
    
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js